function sliderFun(parentClass = "product-grid-slider"){
  var counter = 20;
  var slickInterval = setInterval(function(){
    if($("." + parentClass + " li").length > 0){
      clearInterval(slickInterval);
      $("." + parentClass ).slick({
        slidesToShow: 4,
        arrows:true,
        infinite:true,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        dots:false,
        responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 990,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 475,
          settings: {
            slidesToShow: 1,
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
      });
     setTimeout(function(){
       window.dispatchEvent(new Event("resize"));
      }, 200);
    }
    if(counter <= 0){
      clearInterval(slickInterval);
    }
    counter --;
    
  }, 500);
}